import { useAppSelector } from 'store/index';

export const useNewLocation = () => {
    return useAppSelector(({ locations: { new: newLocation } }) => newLocation);
};

export const useLocationsSearchQuery = () => {
    return useAppSelector(({ locations: { searchQuery } }) => searchQuery);
};
